// extracted by mini-css-extract-plugin
module.exports = {"btn":"voiceHeaderButton_btn__XOooE"};